(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const get = id => form.querySelector('#pi-' + id);
    const value = id => get(id)?.value || '';
    const params = new URLSearchParams(location.search);
    if (params.get('source') === 'solar' && !form.querySelector('.lpi-errors')) {
      if (get('power')) get('power').value = 'Solar power';
      if (get('application')) get('application').value = 'Agricultural irrigation';
      if (get('entry')) get('entry').value = 'Solar / irrigation category';
    }
    function update() {
      const rules = {
        well: value('source') === 'Well / borehole',
        solar: ['Solar power', 'Solar + mains / generator'].includes(value('power')),
        'other-power': value('power') === 'Other'
      };
      root.querySelectorAll('[data-show-when]').forEach(group => {
        const visible = !!rules[group.dataset.showWhen];
        group.hidden = !visible;
        group.querySelectorAll('input, select, textarea').forEach(input => { input.disabled = !visible; });
      });
    }
    form.addEventListener('change', update);
    update();
    const success = form.querySelector('.lpi-success');
    if (success) success.focus({ preventScroll: true });
    if (form.querySelector('.lpi-errors')) {
      const error = form.querySelector('.lpi-errors');
      error.setAttribute('tabindex', '-1');
      error.focus({ preventScroll: true });
    }
  }
  const initializeAll = scope => scope.querySelectorAll('[data-project-inquiry]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
